<template>
  <div v-if="result" class="blog-similar-card">
    <a :href="result.detailPage" class="blog-similar-card__picture">
      <DefImg :result="result.picture" />
    </a>
    <div v-if="result.activeFrom" class="blog-similar-card__inform">
      <!--            <BlogSimilarLabels />-->
      <span v-if="result.activeFrom" class="blog-similar-card__date">
        {{ result.activeFrom }}
      </span>
    </div>
    <a :href="result.detailPage" class="blog-similar-card__name">
      {{ result.name }}
    </a>
    <DefLink :href="result.detailPage">
      {{ messages.detail }}
    </DefLink>
  </div>
</template>

<script lang="ts" setup>
import DefImg from '@components/Def/DefImg/DefImg.vue';
import DefLink from '@components/Def/DefLink/DefLink.vue';
import { useResultsStore } from '@/storePinia/stores/results';
import { storeToRefs } from 'pinia';
// import BlogSimilarLabels from './BlogSimilarLabels';

const { messages } = storeToRefs(useResultsStore());

const props = defineProps(['result']);
</script>

<style lang="scss" scoped>
.blog-similar-card {
  display: flex;
  flex-direction: column;
  &__picture {
    display: block;
  }
  &__name {
    font-weight: 600;
    font-size: 14px;
    line-height: 125%;
    margin-bottom: 24px;
    @include point-md {
      font-size: 16px;
      line-height: 135%;
      margin-bottom: 22px;
    }
  }
  &__inform {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
  }
  &__date {
    font-weight: 600;
    font-size: 12px;
    color: #5f5f67;
  }
  :deep(.def-img) {
    margin-bottom: 16px;
  }
  :deep(.def-link) {
    font-size: 12px;
  }
}
</style>
